<template>
  <div>
    <v-form :name="searchProps.formName" @keyup.enter="autoSearch = true">
      <Tabs value="0" scrollable>

        <TabList class="mb-4">
          <Tab value="0">{{ __('Basic data') }}</Tab>
        </TabList>

        <TabPanels>
          <TabPanel value="0">
            <div class="grid">
              <FormInputText fieldName="status_category" label="Category" size="4" :isFocus="true"
                v-model:field="search.status_category" />

              <FormInputText fieldName="status_symbol" label="Symbol" size="4" v-model:field="search.status_symbol" />

              <FormInputText fieldName="status_name" label="Name" size="4" v-model:field="search.status_name" />
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>

      <div class="grid">
        <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
      </div>
    </v-form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})

const autoSearch = ref(false)

let search = ref({})
prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
